import type { FaireProductEntity } from "../../entity_types/product";

export const p_kc7thnupg5: FaireProductEntity = {
  token: "p_kc7thnupg5",
  type: "product",
  name: "Grateful Dead Steal Your Face Sublimation Tye Dye Socks",
  brandToken: "b_5xdelgfsdc",
  brandName: "Gypsy Rose",
  imageUrl:
    "https://cdn.faire.com/fastly/cf9ad236b61b2ea742463aa4116abad71f163f3e6eba74549089b1e3d782c51a.png",
  galleryImageUrls: [],
  priceDollars: 11,
  description:
    "Unleash your inner Deadhead with these officially licensed Grateful Dead Steal Your Face Sublimation Tye Dye Socks!\n\n• Vibrant tie-dye pattern with the iconic Steal Your Face skull logo\n• Soft, breathable material for all-day comfort\n• Unisex size fits men and women shoe sizes 6-12\n• Officially licensed Grateful Dead merchandise\n\nThese eye-catching socks are the perfect way to show off your love for the legendary Grateful Dead. The bold tie-dye design and instantly recognizable Steal Your Face logo will make you the envy of every Deadhead. Crafted from high-quality, breathable material, these socks will keep your feet comfortable all day long. Whether you're headed to a Dead & Company show or just running errands, these socks are a must-have for any true fan.",
  tags: [],
  msrpDollars: 22,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-05T00:27:27.810Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
